import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';  // Importamos el entorno
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  private apiUrl = environment.apiUrl;  // Usamos la URL del entorno
  private routerApi = 'api/category';  // Usamos la URL de la API de productos

  private categoriesLoadedSubject = new BehaviorSubject<boolean>(false);
  categoriesLoaded$ = this.categoriesLoadedSubject.asObservable();

  constructor(private http: HttpClient, private authService: AuthService) {}

  // Obtener productos con filtros
  getAllCategory(showSubcategories: string = 'true'): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });

    // Usa `page` como un parámetro de ruta y los filtros como parámetros de consulta
    let params = new HttpParams().set('showSubcategories', showSubcategories);
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/web`, { headers, params });
  }

  // Obtener productos con filtros
  getAllCategoryDest(): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });

    // Usa `page` como un parámetro de ruta y los filtros como parámetros de consulta
    let params = new HttpParams()
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/favorite`, { headers, params });
  }
    // Crear un nueva categoria
    createCategory(category): Observable<any> {
      return this.http.post<any>(`${this.apiUrl}/${this.routerApi}`, category);
    }
   // Obtener categoría por ID
   getCategoryById(id: string): Observable<any> {
    const token = this.authService.getUserData()?.token;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/web/${id}`, { headers });
  }
  // Actualizar categoría
  updateCategory(category: any, updatedCategory: { name: any; subcatList: any[]; }): Observable<any> {
    const token = this.authService.getUserData()?.token;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this.http.put<any>(`${this.apiUrl}/${this.routerApi}/${category}`, updatedCategory, { headers });
  }
   // Eliminar una categoría por ID
   deleteCategory(id: string): Observable<any> {
    const token = this.authService.getUserData()?.token;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.delete<any>(`${this.apiUrl}/${this.routerApi}/${id}`, { headers });
  }

  setCategoriesLoaded(loaded: boolean): void {
    this.categoriesLoadedSubject.next(loaded);
  }
}
